<script>
import { Line } from "vue-chartjs";

export default {
  extends: Line,
  props: {
    chartData: {
      type: Array,
      required: true
    },
    chartLabels: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      chartDataset: {
        labels: this.chartLabels,
        datasets: [
          {
            data: this.chartData,
            backgroundColor: "rgba(50, 50, 50, 0.5)",
            borderWidth: 0
          }
        ]
      },
      chartOptions: {
        maintainAspectRatio: false,
        layout: {
          padding: {
            top: 20
          }
        },
        elements: {
          point: {
            radius: 7,
            hoverRadius: 8
          }
        },
        legend: {
          display: false
        },
        scales: {
          yAxes: [
            {
              display: false,
              ticks: {
                beginAtZero: true
              }
            }
          ]
        },
        tooltips: {
          enabled: false
        },
        onClick: this.selectMonth,
        plugins: {
          datalabels: {
            display: c => {
              let index = c.dataIndex;
              let value = c.dataset.data[index];
              return value != 0;
            },
            align: "end",
            offset: 5
          }
        }
      }
    };
  },
  methods: {
    selectMonth(event, array) {
      let clickedId = array[0]["_index"];
      let index = this.$store.state.filters.month.indexOf(
        this.chartLabels[clickedId]
      );
      if (index > -1) this.$store.state.filters.month.splice(index, 1);
      else this.$store.state.filters.month.push(this.chartLabels[clickedId]);
    }
  },
  mounted() {
    this.renderChart(this.chartDataset, this.chartOptions);
  },
  watch: {
    chartData() {
      this.chartDataset.datasets[0].data = this.chartData;
      this.chartDataset.labels = this.chartLabels;
      this.$data._chart.update();
    }
  }
};
</script>